/**
 * @generated SignedSource<<201189f7f7efb4c343ed5096073b2027>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentDashboardBlockFullContentFragment$data = {
  readonly contentUsages: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly content: {
          readonly coverPhoto: string | null;
          readonly coverVideo: string | null;
          readonly coverVideoAssetUsage: {
            readonly asset: {
              readonly id: string;
              readonly " $fragmentSpreads": FragmentRefs<"DiscoVideoFragment">;
            };
            readonly id: string;
          } | null;
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"ContentCard_ContentFragment" | "ContentTitleSectionFragment">;
        };
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"ContentCard_ContentUsageFragment">;
      };
    }>;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ContentDashboardBlockAdminDropdownFragment">;
  readonly " $fragmentType": "ContentDashboardBlockFullContentFragment";
};
export type ContentDashboardBlockFullContentFragment$key = {
  readonly " $data"?: ContentDashboardBlockFullContentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentDashboardBlockFullContentFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentDashboardBlockFullContentFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentUsageNodeConnection",
      "kind": "LinkedField",
      "name": "contentUsages",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentUsageNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ContentUsage",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ContentCard_ContentUsageFragment"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Content",
                  "kind": "LinkedField",
                  "name": "content",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "coverPhoto",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "coverVideo",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AssetUsage",
                      "kind": "LinkedField",
                      "name": "coverVideoAssetUsage",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Asset",
                          "kind": "LinkedField",
                          "name": "asset",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "DiscoVideoFragment"
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "ContentCard_ContentFragment"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "ContentTitleSectionFragment"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContentDashboardBlockAdminDropdownFragment"
    }
  ],
  "type": "ContentDashboardBlock",
  "abstractKey": null
};
})();

(node as any).hash = "6d10a29b3c99ae9f8d5dc438974b0c27";

export default node;
